import config from 'src/config';
import { httpClient } from 'src/utils/axios';
import { PostUploadRequest } from '../types/votacao';

export function postUploadFile(params: PostUploadRequest) {
  const formData = new FormData();
  params.arquivos.forEach((file, i) =>
    formData.append(`arquivo${i ? i : ''}`, file, file?.name || '')
  );
  formData.append('codTipoArquivo', String(params.codTipoArquivo));

  return httpClient<string>({
    method: 'POST',
    url: `${config.backend.apiAssembleias}/api/v1/utils/uploadFile`,
    data: formData,
    withCredentials: true
  });
}
